import React from 'react';
import { connect } from 'react-redux';
import { DatePicker } from 'elements/';
import PropTypes from 'prop-types';
import SearchBox from '../../../../elements/SearchBox/SearchBox';
import {
    DateSelection,
    DatePickerStyle,
    DateFilter,
    DateButton,
    TestStatusLabel,
    FlexContainer
} from './DateSection.styled';
import { setDatePicker, searchMODescription, setAndFilterMoData } from '../MOSelection.actions';
import { FormDropdown } from '../../../../elements/Dropdown';
import { width } from '../MOSelection.constants';

const DateSection = (props) => {
    const { startDate, endDate, setMODatePicker, searchCriteria, triggerSearch, testStatusFilterMo, testStatusFiltersMo, tagsLoaded, tagsBiLoaded } = props;

    const handleSearch = async (searchValue, name) => {
        await triggerSearch(searchValue, name);
    };

    const handleSelection = (event) => {
        const keyName = Object.keys(event);
        if (keyName[0] === 'startDate') {
            setMODatePicker('Custom', event.startDate, endDate);
        } else if (keyName[0] === 'finishDate') {
            setMODatePicker('Custom', startDate, event.finishDate);
        }
    };

    const dateFilterHandler = (e) => {
        setMODatePicker(e.target.name);
    };

    return (
        <DateSelection>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start', width: '100%' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'start' }}>
                        <DatePickerStyle>
                            <DatePicker
                                name="startDate"
                                label="Start Date:"
                                value={startDate}
                                fontSize="11pt"
                                width="200px"
                                onChange={(event) => handleSelection({ startDate: event })}
                            />
                            <DatePicker
                                name="finishDate"
                                label="Finish Date:"
                                width="200px"
                                value={endDate}
                                fontSize="11pt"
                                onChange={(event) => handleSelection({ finishDate: event })}
                            />
                        </DatePickerStyle>
                        <FlexContainer>
                            <TestStatusLabel>Test Status:</TestStatusLabel>
                            <FormDropdown
                                id="TestStatus"
                                name="Test Status"
                                noDefaultOption
                                value={testStatusFilterMo}
                                options={[{ name: 'All', value: 'All' }, { name: 'Tested', value: 'Tested' }, { name: 'Not Tested', value: 'Not Tested' }]}
                                width="200px"
                                height="27px"
                                handleChange={(obj) => testStatusFiltersMo(obj['Test Status'])}
                                readOnly={!(tagsLoaded && tagsBiLoaded)}
                            />
                        </FlexContainer>
                    </div>
                    <div style={{ display: 'flex', width: '115%' }}>
                        <div style={{ width: width.moNumber }}>
                            <SearchBox
                                value={searchCriteria.moNumber}
                                handleSearch={handleSearch}
                                name="moNumber"
                                height="27px"
                                placeholder="MO Number"
                                fontSize="7.5pt"
                                padding="0px 5px"
                                borderColor="var(--primary)"
                            />
                        </div>
                        <div style={{ width: width.moDescription }}>
                            <SearchBox
                                value={searchCriteria.moDescription}
                                name="moDescription"
                                handleSearch={handleSearch}
                                height="27px"
                                placeholder="MO Description"
                                fontSize="7.5pt"
                                padding="0px 5px"
                                borderColor="var(--primary)"
                            />
                        </div>
                        <div style={{ width: width.floc }}>
                            <SearchBox
                                value={searchCriteria.functionalLocation}
                                handleSearch={handleSearch}
                                name="functionalLocation"
                                placeholder="Functional Location"
                                height="27px"
                                fontSize="7.5pt"
                                padding="0px 5px"
                                borderColor="var(--primary)"
                            />
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', minWidth: '15%' }}>
                    <DateFilter>
                        <DateButton>
                            <button name="All" type="submit" onClick={dateFilterHandler}>
                                ALL
                            </button>
                            <button name="Today" type="submit" onClick={dateFilterHandler}>
                                Today
                            </button>
                            <button name="Tomorrow" type="submit" onClick={dateFilterHandler}>
                                Tomorrow
                            </button>
                        </DateButton>
                    </DateFilter>
                </div>
            </div>
        </DateSelection>
    );
};

const mapStateToProps = ({ MOSelection, Home }) => ({
    startDate: MOSelection.startDate,
    endDate: MOSelection.endDate,
    moDataAll: MOSelection.moDataAll,
    searchCriteria: MOSelection.searchCriteria,
    testStatusFilterMo: MOSelection.testStatusFilterMo,
    filteredMoData: MOSelection.filteredMoData,
    tagsLoaded: Home.tagsLoaded,
    tagsBiLoaded: Home.tagsBiLoaded,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    setMODatePicker: (type, customStartDate, customEndDate) => dispatch(setDatePicker(type, customStartDate, customEndDate)),
    triggerSearch: (obj, name) => dispatch(searchMODescription(obj, name)),
    testStatusFiltersMo: (filter) => dispatch(setAndFilterMoData(filter))
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DateSection);

DateSection.propTypes = {
    endDate: PropTypes.any,
    searchCriteria: PropTypes.object,
    setMODatePicker: PropTypes.func,
    startDate: PropTypes.any,
    tagsBiLoaded: PropTypes.bool,
    tagsLoaded: PropTypes.bool,
    testStatusFilterMo: PropTypes.string,
    testStatusFiltersMo: PropTypes.func,
    triggerSearch: PropTypes.func,
};
